import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "sf-form-group" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, " Username* ", -1)
const _hoisted_5 = { class: "tw-flex" }
const _hoisted_6 = {
  key: 0,
  class: "tw-w-32"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "tw-px-2 tw-py-3 tw-text-xl tw-font-bold" }, "-", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "tw-flex-grow" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, " Password* ", -1)
const _hoisted_12 = {
  key: 0,
  class: "tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-full"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-bg-mainbg1 tw-opacity-[0.75]" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center tw-text-primary" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tw-text-center" }, [
    /*#__PURE__*/_createElementVNode("div", null, "Successful login"),
    /*#__PURE__*/_createElementVNode("div", null, "Redirecting to the dashboard")
  ])
], -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { key: 2 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, " Email* ", -1)
const _hoisted_18 = {
  key: 3,
  class: "tw-mb-4"
}
const _hoisted_19 = { class: "tw-relative tw-top-0 tw-left-0" }
const _hoisted_20 = { class: "tw-text-danger tw-absolute tw-top-0 tw-right-0 tw-left-[150px] tw-text-center" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = {
  key: 0,
  type: "submit",
  class: "sf-btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactLink = _resolveComponent("ContactLink")!
  const _component_FormInput = _resolveComponent("FormInput")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", {
      onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
    }, [
      (_ctx.loginMode == 'mf')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createTextVNode(" Only available for individual mathsframe users. For school users pelase "),
            _createVNode(_component_ContactLink)
          ]))
        : _createCommentVNode("", true),
      (_ctx.screen == 'login' || _ctx.screen == 'loggedin')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.loginMode == 'sf')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_FormInput, {
                          modelValue: _ctx.loginFormData.fields.username_a,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loginFormData.fields.username_a) = $event)),
                          "class-name": "sf-username-a"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginFormData.fields.username_a.value) = $event)),
                              ref: "usernameA",
                              name: "username_a",
                              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onUsernameAChange && _ctx.onUsernameAChange(...args))),
                              onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onUsernameAInput && _ctx.onUsernameAInput(...args))),
                              class: "sf-form-control tw-w-full"
                            }, null, 544), [
                              [_vModelText, _ctx.loginFormData.fields.username_a.value]
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loginMode == 'sf')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_FormInput, {
                      modelValue: _ctx.loginFormData.fields.username_b,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.loginFormData.fields.username_b) = $event)),
                      "class-name": "sf-username-b"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.loginFormData.fields.username_b.value) = $event)),
                          ref: "usernameB",
                          name: "username_b",
                          class: "sf-form-control tw-w-full"
                        }, null, 512), [
                          [_vModelText, _ctx.loginFormData.fields.username_b.value]
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createVNode(_component_FormInput, {
                modelValue: _ctx.loginFormData.fields.password,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.loginFormData.fields.password) = $event))
              }, {
                default: _withCtx(() => [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.loginFormData.fields.password.value) = $event)),
                    name: "password",
                    class: "sf-form-control tw-w-full",
                    autocomplete: "off"
                  }, null, 512), [
                    [_vModelText, _ctx.loginFormData.fields.password.value]
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            (_ctx.screen == 'loggedin')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.screen == 'forgot')
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(_component_FormInput, {
                modelValue: _ctx.forgotFormData.fields.email,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.forgotFormData.fields.email) = $event))
              }, {
                default: _withCtx(() => [
                  _hoisted_17,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.forgotFormData.fields.email.value) = $event)),
                    ref: "email",
                    class: "sf-form-control tw-w-full"
                  }, null, 512), [
                    [_vModelText, _ctx.forgotFormData.fields.email.value]
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : (_ctx.screen == 'sent')
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, " If there is an account registered under this addres an email will be sent soon with instructions to reset your password "))
            : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          (_ctx.errorName == 'connectionLimit')
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, " You are logged on on another device or browser. You need to log off or wait 20 minutes to log on again. "))
            : (_ctx.errorName == 'loginInvalid')
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, " Wrong username / password. "))
              : (_openBlock(), _createElementBlock("div", _hoisted_23, " "))
        ])
      ]),
      _createElementVNode("div", null, [
        (_ctx.screen != 'sent')
          ? (_openBlock(), _createElementBlock("button", _hoisted_24, _toDisplayString(_ctx.submitLabel), 1))
          : _createCommentVNode("", true)
      ])
    ], 32)
  ]))
}